import { Box, Flex } from "@chakra-ui/react";
import { useState, useEffect } from "react";
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { removeCompletedUploadProgressMetric } from "../../../../digital-sales-room/actions/dsr-actions";

const LaunchdeckTextLoader = ({ copyText, color, fontSize, postId, percentProcessed, resetUploadProgressMetric }) => {
	const [dotCount, setDotCount] = useState(0);
	const [showFinalizingState, setShowFinalizingState] = useState(false)
	
	useEffect(() => {
		if (percentProcessed === 100) {
			// resetUploadProgressMetric();
			removeCompletedUploadProgressMetric({postId: postId})
			setShowFinalizingState(true)
		}
	}, [percentProcessed, resetUploadProgressMetric]);

	useEffect(() => {
		const interval = setInterval(() => {
			setDotCount(prev => (prev < 3 ? prev + 1 : 0)); // Cycle 0 → 1 → 2 → 3 → 0
		}, 500);

		return () => clearInterval(interval);
	}, []);



	return (
		<span>
			<Flex gap='0.2em'>
				{showFinalizingState ?
					<Box color={color || "gray.500"} fontSize={fontSize || "0.875em"}>Saving</Box>
					:
					<Box color={color || "gray.500"} fontSize={fontSize || "0.875em"}>{copyText || "Loading"} {percentProcessed ? percentProcessed + "%" : ""}</Box>
				}
				<Flex color={color || "gray.500"} fontSize={fontSize || "0.875em"}>
					<span style={{ visibility: dotCount > 0 ? "visible" : "hidden" }}>.</span>
					<span style={{ visibility: dotCount > 1 ? "visible" : "hidden" }}>.</span>
					<span style={{ visibility: dotCount > 2 ? "visible" : "hidden" }}>.</span>
				</Flex>
			</Flex>
		</span>
	)
};

const mapStateToProps = (state, ownProps) => {
	return {
		percentProcessed: ownProps.subWidgetId
			? state.fileUploadPercentProcessed.fileUploadProgress[ownProps.subWidgetId] || 0
			: ownProps.postId
				? state.fileUploadPercentProcessed.fileUploadProgress[ownProps.postId] || 0
				: state.fileUploadPercentProcessed.fileUploadProgress.global || 0
	};
};
const mapDispatchToProps = (dispatch) =>
	bindActionCreators(
		{
			removeCompletedUploadProgressMetric
		},
		dispatch,
	)


export default connect(mapStateToProps, mapDispatchToProps)(LaunchdeckTextLoader);
